module.exports = __webpack_public_path__ + "img/2019-homematch.22e0d622.jpg";